"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const useSubscribeData_1 = require("./useSubscribeData");
function useGetLocale() {
    var _a;
    return (_a = (0, useSubscribeData_1.default)('game', 'locale')) !== null && _a !== void 0 ? _a : '';
}
exports.default = useGetLocale;
